module.exports = __webpack_public_path__ + "static/media/dot.db279caf.svg";